import Vue from 'vue';
import watermark from '@dp/watermark';
import router from '@/router';

import App from './App.vue';
import store from './store/index';
import sso, { ssoWeb } from './utils/sso';

import './utils/moment-setup';

import '@ss/mtd-vue/lib/theme2/index.css';
import MTD from '@ss/mtd-vue';
import MTDChart from '@ss/mtdv';
import VueClipboard from 'vue-clipboard2';

Vue.use(VueClipboard);
Vue.use(MTD);
Vue.component('Chart', MTDChart);

Vue.config.productionTip = false;

if (process.env.NODE_ENV !== 'development') {
  // 增加水印
  watermark(document.body, {
    backgroundColor: '#f2f4f9',
    urlPrefix: '/api-wm',
  });
}
// with promise
// const ssoId = sso.getSsoid();
// console.log('ssoId' + ssoId);
ssoWeb.login().then(ssoid => {
  if (typeof ssoid === 'string') {
    sso.setSsoid(ssoid);
    store.dispatch('api_get_login_user').then(() => {
      new Vue({
        router: router,
        store,
        render: h => h(App),
      }).$mount('#app');
    });
  } else {
    const ssoId = sso.getSsoid();
    if (ssoId) {
      store.dispatch('api_get_login_user').then(() => {
        new Vue({
          router: router,
          store,
          render: h => h(App),
        }).$mount('#app');
      });
    } else {
      new Vue({
        router,
        store,
        render: h => h(App),
      }).$mount('#app');
    }
  }
});
